"use client"
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function MeetYourComplianceRequirements({ blok }) {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
  const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
  const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
  return (
    <div className="">
      <div
        className="bg-asmPageTopBG"
        style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "bottom", // Center the background image
          backgroundRepeat: "repeat", // Prevent repeating the background
          // maxWidth: 1920,
          // margin: "auto",
        }}
      >
        <div className="max-w-[1920px] m-auto flex justify-center">
          <div className="relative lg:flex flex-col items-center py-8 max-w-[1500px] w-full">
            {/* Header Section */}
            <div className="font-aileron py-20 lg:py-32 text-center font-bold max-w-7xl">
              <h2 className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[80px]">
                {blok.Hero?.[0]?.header}
              </h2>
              <div className="font-lato mt-4 text-[20px] w-[80%] lg:w-[100%] m-auto lg:text-[32px] font-normal">
                {blok.Hero?.[0]?.subheader}
              </div>
            </div>

            <div className='py-6 w-full flex justify-center'>
                            {/* Main Content Section */}
                            <div className="shadow-2xl max-w-[1920px] items-center  py-10 z-20 lg:mb-10 bg-white rounded-[20px] lg:-mt-20 p-10 w-full flex justify-center">
                                <div className='lg:flex justify-center lg:gap-[100px] max-w-[1200px]'>
                                    <div className='lg:flex justify-center max-w-7xl items-center lg:gap-[100px]'>
                                        {/* Left Column (Main Image) */}
                                        <div ref={ref1} className="w-full max-w-md">
                                            <div className="lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                                                <motion.img
                                                    initial={{ opacity: 0, x: -100 }}
                                                    animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                                                    transition={{ duration: 0.5, delay: 0.2 }}
                                                    src={blok.HeroCard?.[0]?.image?.filename} />
                                            </div>
                                        </div>

                                        <div className="lg:flex-1">

                                            {/* Description */}
                                            <p className="font-lato text-[16px] lg:text-[20px] lg:mb-6 mb-6 m-auto text-center lg:text-start lg:m-0">
                                                {blok.HeroCard?.[0]?.description}
                                            </p>
                                            <div className="flex lg:justify-start justify-center">
                                                <a href={"/" + blok.HeroCard?.[0]?.url?.cached_url} className="flex items-center justify-center bg-[#EF7B22] px-[16px] py-[14px] font-lato text-white rounded hover:bg-[#d7691d] transition duration-150 text-[16px]">
                                                    {blok.HeroCard?.[0]?.ctaText}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
          </div>
        </div>
      </div>
      <div className="bg-useCaseBottomBG bg-cover">
        <div
          style={{
            backgroundSize: "cover", // Ensure the image covers the entire section
            backgroundPosition: "center", // Center the background image
            backgroundRepeat: "repeat", // Prevent repeating the background
            margin: "auto",
          }}
        >
          <div className="flex flex-col items-center text-center justify-center mb-10 mt-10 lg:mt-0">
            <div className="mb-10 w-full">
              <div className="flex justify-center mb-10">
                <h6 className="font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] font-bold px-6">
                  {blok.Benefits?.find(item => item.component == "Heading")?.header}                  </h6>
              </div>

              {/* Benefits Grid */}
              <div
                ref={ref2}
                className="grid lg:grid-cols-3 gap-6 lg:gap-x-10 w-full max-w-[1200px] mx-auto justify-center"
              >
                {blok?.Benefits?.filter(item => item.component == "GenericCards")?.map((item, index) => {
                  return <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -100 }}
                    animate={isInView2 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="relative w-[346px] rounded-lg p-[4px] bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                    {/* Inner content div */}
                    <div className="h-full w-full gap-2 bg-ASMBenefitsBg rounded-lg flex flex-col justify-between items-center text-center p-4">
                      <img src={item.image.filename} className="h-[106px] w-[106px] mb-6" />
                      <p className="font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2">{item.title}</p>
                      <p className="text-[18px] font-lato">{item.description}</p>
                    </div>
                  </motion.div>
                })}
              </div>
            </div>
          </div>
          <div ref={ref3} className='relative lg:pb-20 px-4'>
            <div className='lg:pb-20 relative flex justify-center'>
              <div className="font-aileron pb-20 lg:py-0 text-center font-bold relative">
                <div className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] mb-10">
                  {blok?.Explore?.[0].header}
                </div>
                <div className='lg:w-[463px] lg:h-[455px] w-full'>
                  <motion.div
                    initial={{ opacity: 0, y: -100 }}
                    animate={isInView3 ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="lg:w-[463px] lg:h-[455px] w-[200px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                    <img src={"/images/ASRMoreToExplore.svg"} />
                  </motion.div>
                  <div className='lg:absolute bottom-[30%] left-[-80%] lg:text-end mb-10 lg:mb-0 lg:w-[70%]'>
                    <div className="font-lato bg-custom-radial bg-clip-text text-transparent font-bold  m-auto text-[20px] lg:text-[24px]">
                      {blok?.Explore?.[1].header}
                    </div>
                    <div className="font-lato text-[20px] m-auto lg:text-[18px] font-normal mb-2">
                      {blok?.Explore?.[1].subheader}
                    </div>
                    {/* <a href='#' className='font-lato text-[#E56717] lg:mr-40'>{"Learn More >"}</a> */}
                  </div>
                  <div className='lg:absolute bottom-[55%] right-[-70%] lg:text-start mb-10 lg:mb-0 lg:w-[70%]'>
                    <div className="font-lato bg-custom-radial bg-clip-text text-transparent font-bold mt-4 text-[20px]  m-auto lg:text-[24px]">
                      {blok?.Explore?.[2].header}
                    </div>
                    <div className="font-lato text-[20px] m-auto lg:text-[18px] font-normal mb-2">
                      {blok?.Explore?.[2].subheader}
                    </div>
                    {/* <a href='#' className='font-lato text-[#E56717] lg:ml-[120px]'>{"Learn More >"}</a> */}
                  </div>
                  <div className='lg:absolute bottom-[2%] right-[-70%] lg:text-start lg:w-[70%]'>
                    <div className="font-lato bg-custom-radial bg-clip-text text-transparent font-bold mt-4 text-[20px] m-auto lg:text-[24px]">

                      {blok?.Explore?.[3].header}

                    </div>
                    <div className="font-lato text-[20px]  m-auto lg:text-[18px] font-normal mb-2">
                      {blok?.Explore?.[3].subheader}
                    </div>
                    {/* <a href='#' className='font-lato text-[#E56717] lg:ml-[35px]'>{"Learn More >"}</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <Footer blok={blok} /> */}
        </div>
      </div>
    </div>
  );
}

export default MeetYourComplianceRequirements;
